export enum EScwAppModule {
  actionTracker = 'actionTracker',
  digitalBoards = 'digitalBoards',
  oeeTracker = 'oeeTracker',
  digitalLogbook = 'digitalLogbook',
}

export interface IScwAppModuleItem {
  name: string;
  moduleName: EScwAppModule;
  link?: string;
  isCurrentTool?: boolean;
  disabled?: boolean;
}

export type TScwAppModules = Record<EScwAppModule, string | undefined>;
